import {Injectable} from '@angular/core';
import {DomService} from './dom.service';
import {BehaviorSubject} from 'rxjs/BehaviorSubject';

@Injectable()
export class ModalService {

    constructor(private domService: DomService) {
    }

    public modalElementId = 'my-modal';
    public overlayElementId = 'my-modal-overlay';
    public fullScreenDefault: Boolean = false;
    public _showHidePlayerBalance = new BehaviorSubject<boolean>(true);
    private _component;
    private _inputs;
    private _outputs;

    init(component: any, inputs: object, outputs: object, fullScreen?: Boolean, classObject?: Object) {
        if (classObject) {
            this.modalElementId = classObject['modalElementId'];
            this.overlayElementId = classObject['overlayElementId'];
        } else {
            this.modalElementId = 'modal-1';
            this.overlayElementId = 'modal-backdrop-1';
        }
        this.destroy();

        this._showHidePlayerBalance.next(false);

        this.fullScreenDefault = fullScreen;
        this._component = component;
        this._inputs = inputs;
        this._outputs = outputs;

        const componentConfig = {
            inputs: this._inputs,
            outputs: this._outputs
        };
        this.domService.appendComponentTo(this.modalElementId, this._component, componentConfig);
        document.getElementById(this.modalElementId).classList.remove('hidden');
        document.getElementById(this.overlayElementId).classList.remove('hidden');
        document.getElementById(this.modalElementId).classList.add('show');
        document.getElementById(this.overlayElementId).classList.add('show');
        if (this.fullScreenDefault) {
            document.getElementById(this.modalElementId).classList.add('full-screen');
            document.body.classList.add('no-scroll');
        } else {
            document.body.classList.add('game-modal-header');
        }
    }

    destroy() {
        this.domService.removeComponent();
        document.getElementById(this.modalElementId).classList.remove('show');
        document.getElementById(this.overlayElementId).classList.remove('show');
        document.getElementById(this.modalElementId).classList.add('hidden');
        document.getElementById(this.overlayElementId).classList.add('hidden');
        document.getElementById(this.modalElementId).classList.remove('full-screen');
        document.body.classList.remove('no-scroll');
        this._showHidePlayerBalance.next(true);
    }

    public fullScreen() {
        if (this.fullScreenDefault === true) {
            document.getElementById(this.modalElementId).classList.add('full-screen');
            document.body.classList.add('no-scroll');
        } else {
            document.getElementById(this.modalElementId).classList.remove('full-screen');
            document.body.classList.remove('no-scroll');
        }
    }
}



// WEBPACK FOOTER //
// C:/Users/beyn/Documents/GitLab/spinmatic-casino/src/app/Modules/Shared/services/modal.service.ts